import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import StyledButton from './TabButton';
import { calculateRem } from '@uie/javascript-style-helpers';
import { colors } from '@vds-core/theme';
import { TitleConfig, TypographyConfig, Title as CoreTitle } from '@vds-core/typography';
import UNSAFE_SetEnvRef from '@uie/set-env-ref';
import ReactDOM, { findDOMNode } from 'react-dom';
import { withVDSManager } from '@vds-core/utilities';
var propTypes = {
  /**
   * The text label of the tab.
   */
  label: PropTypes.string.isRequired,

  /**
   * An optional callback that is called when this Tab is clicked. Passes parameters (event, tabIndex).
   */
  onClick: PropTypes.func,

  /**
   * If provided, it will set this Tab to the Active Tab on render.
   * @note This will override whatever was set on the Tab selectedIndex prop. Also, it is "Last One Wins", ie: if this is set on multiple Tab elements, the last element with it set will be the Active Tab.
   */
  active: PropTypes.bool,

  /**
   * If true, the Tab element will not be visible and removed from the DOM
   */
  hide: PropTypes.oneOf([true, false, 0, 1, 2]),

  /**
   * Minimum Width of this Tab when orientation is horizontal.
   */
  minWidth: PropTypes.string,

  /**
   * @ignore
   */
  indicatorFillTab: PropTypes.bool,

  /**
   * @ignore
   */
  indicatorPosition: PropTypes.oneOf(['bottom', 'top', 'none']),

  /**
   * If provided, this will be used instead of the random uniqueId generated by the Tabs Component that is used to associate the Tab li and button with the TabPanel div components.
   */
  uniqueId: PropTypes.string,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  handleVisibilityChange: PropTypes.func,

  /**
   * @ignore
   */
  onVisibilityChange: PropTypes.func,

  /**
   * @ignore
   * Supplies a set height on the tab component.
   */
  tabHeight: PropTypes.string,

  /**
   * @deprecated minWidth
   */
  minTabWidth: PropTypes.string,

  /**
   * @deprecated indicatorFillTab
   */
  accentFill: PropTypes.bool,

  /**
   * @deprecated indicatorPosition
   */
  accentPosition: PropTypes.oneOf(['bottom', 'top', 'none']),

  /**
   * @deprecated active
   */
  isActive: PropTypes.bool,

  /**
   * @ignore
   */
  focusState: PropTypes.bool,

  /**
   * @ignore
   */
  minHeight: PropTypes.bool,

  /**
   * @ignore
   */
  typescale: PropTypes.string,

  /**
   * @ignore
   */
  titleConfig: PropTypes.object,

  /**
   * @ignore
   */
  tabSpacing: PropTypes.string,

  /**
   * @ignore
   */
  colorConfig: PropTypes.object,

  /**
   * @ignore
   */
  Title: PropTypes.func,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  inverted: PropTypes.bool,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-analyticstrack': PropTypes.string,

  /**
   * Allows a string to be provided for analytics.
   */
  'data-track': PropTypes.string,

  /**
   * Allows a string to be provided for click stream.
   */
  'data-clickstream': PropTypes.string
};
var defaultProps = {
  hide: false,
  minWidth: undefined,
  className: null,
  typescale: TypographyConfig.getTypescale(),
  titleConfig: TitleConfig,
  tabSpacing: calculateRem(0, 40, 0, 0),
  colorConfig: colors
};
var StyledTab = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledTab",
  componentId: "sc-eyuyma-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  outline: none;\n  margin: ", ";\n  min-width: ", ";\n  :last-child {\n    margin: 0;\n  }\n  button {\n    width: max-content;\n  }\n"])), function (_ref) {
  var tabSpacing = _ref.tabSpacing;
  return tabSpacing;
}, function (_ref2) {
  var minWidth = _ref2.minWidth,
      minTabWidth = _ref2.minTabWidth;
  return minWidth ? minWidth : minTabWidth;
});
var ItemWrapper = /*#__PURE__*/styled.span.withConfig({
  displayName: "ItemWrapper",
  componentId: "sc-eyuyma-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-bottom: 16px;\n  text-decoration: none;\n  &:last-child {\n    margin-bottom: 0px;\n  }\n  &:focus {\n    outline: none;\n  }\n"])));
var HitArea = /*#__PURE__*/styled.span.withConfig({
  displayName: "HitArea",
  componentId: "sc-eyuyma-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: block;\n  position: absolute;\n  left: 0;\n  width: 100%;\n  height: 44px;\n  cursor: pointer;\n"])));
var ContentWrapper = /*#__PURE__*/styled.a.withConfig({
  displayName: "ContentWrapper",
  componentId: "sc-eyuyma-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  outline: none;\n  padding: 8px 0px;\n  box-sizing: border-box;\n  padding-left: 16px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  position: relative;\n  z-index: 1;\n  background-color: transparent;\n  text-decoration: none;\n  outline: none;\n  overflow: visible;\n  &:focus:not(:hover) .tabContent {\n    overflow: visible;\n    &::after {\n      display: inline-flex;\n      position: absolute;\n      top: -3px;\n      left: -3px;\n      width: calc(100% + ", ");\n      height: calc(100% + ", ");\n      content: '';\n      border: 1px dashed\n        ", ";\n    }\n  }\n\n  ", "\n  ", ";\n"])), calculateRem(4), calculateRem(4), function (_ref3) {
  var inverted = _ref3.inverted,
      colorConfig = _ref3.colorConfig;
  return inverted ? colorConfig.white : colorConfig.black;
}, function (_ref4) {
  var currentClicked = _ref4.currentClicked,
      colorConfig = _ref4.colorConfig;
  return "\n    &:hover {\n      &::before {\n        background:  ".concat(currentClicked ? colorConfig.red : colorConfig.coolGray6, ";\n        box-shadow: none;\n        content: '';\n        height: 100%;\n        left: -1px;\n        position: absolute;\n        top: 0;\n        width: 4px;\n        z-index: 1;\n      }\n    }\n  ");
}, function (_ref5) {
  var currentClicked = _ref5.currentClicked,
      colorConfig = _ref5.colorConfig;
  return "\n    &::before {\n      background:  ".concat(currentClicked ? colorConfig.red : 'none', ";\n      box-shadow: none;\n      content: '';\n      height: 100%;\n      left: -1px;\n      position: absolute;\n      top: 0;\n      width: 4px;\n      z-index: 1;\n    }\n  ");
});
var TabContent = /*#__PURE__*/styled.span.withConfig({
  displayName: "TabContent",
  componentId: "sc-eyuyma-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n  justify-content: middle;\n  width: auto;\n"])));
export var Tab = /*#__PURE__*/function (_Component) {
  _inherits(Tab, _Component);

  var _super = _createSuper(Tab);

  function Tab(props) {
    var _this;

    _classCallCheck(this, Tab);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "refPath", UNSAFE_SetEnvRef());

    _defineProperty(_assertThisInitialized(_this), "_onClick", function (evt) {
      var _this$props = _this.props,
          onClick = _this$props.onClick,
          uniqueId = _this$props.uniqueId;
      evt.target = document.getElementById(uniqueId);
      if (evt.detail === 0) evt.preventDefault();
      onClick && onClick(evt);
    });

    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", function (e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        _this._onClick(e);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_setRef", function (ref) {
      var _this$props2 = _this.props,
          setRef = _this$props2.setRef,
          viewport = _this$props2.viewport,
          orientation = _this$props2.orientation;
      var domNode = ReactDOM.findDOMNode(ref);

      if (setRef) {
        if ((viewport === 'desktop' || viewport === 'desktopSmall' || viewport === 'tablet') && orientation === 'vertical') {
          setRef(ref);
        } else {
          setRef(domNode && domNode.firstChild);
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "isMobileDevice", function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini|Mobile|mobile/i.test(navigator.userAgent);
    }());

    _this.tabRef = null;
    _this.handleVisibilityChange = props.handleVisibilityChange || props.onVisibilityChange;
    _this.state = {
      selected: props.isActive || props.active
    };
    return _this;
  }

  _createClass(Tab, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(oldProps) {
      if (!this.props.handleVisibilityChange) {
        return;
      }

      if (this.props.isActive !== oldProps.isActive || this.props.active !== oldProps.active) {
        var active = this.props.isActive || this.props.active;
        this.setState({
          selected: active
        });
        this.handleVisibilityChange('isActive', active);
      }

      if (this.props.hide !== oldProps.hide) {
        this.handleVisibilityChange('hide', this.props.hide);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          accentFill = _this$props3.accentFill,
          indicatorFillTab = _this$props3.indicatorFillTab,
          accentPosition = _this$props3.accentPosition,
          indicatorPosition = _this$props3.indicatorPosition,
          hide = _this$props3.hide,
          label = _this$props3.label,
          uniqueId = _this$props3.uniqueId,
          minWidth = _this$props3.minWidth,
          minTabWidth = _this$props3.minTabWidth,
          onClick = _this$props3.onClick,
          className = _this$props3.className,
          tabHeight = _this$props3.tabHeight,
          focusState = _this$props3.focusState,
          minHeight = _this$props3.minHeight,
          height = _this$props3.height,
          typescale = _this$props3.typescale,
          titleConfig = _this$props3.titleConfig,
          tabSpacing = _this$props3.tabSpacing,
          colorConfig = _this$props3.colorConfig,
          analyticsTrack = _this$props3.analyticsTrack,
          track = _this$props3.track,
          clickStream = _this$props3.clickStream,
          orientation = _this$props3.orientation,
          viewport = _this$props3.viewport,
          children = _this$props3.children,
          currentClicked = _this$props3.currentClicked,
          hitArea = _this$props3.hitArea,
          TitleProp = _this$props3.Title,
          dataTrack = _this$props3.dataTrack,
          position = _this$props3.position,
          cta = _this$props3.cta,
          level = _this$props3.level,
          active = _this$props3.active,
          isActive = _this$props3.isActive,
          numberOfTabs = _this$props3.numberOfTabs,
          inverted = _this$props3.inverted;
      var selected = isActive || active;

      if (hide) {
        return null;
      }

      var isDesktop = viewport === 'desktop' || viewport === 'desktopSmall' || viewport === 'tablet';
      var Title = TitleProp ? TitleProp : CoreTitle;
      var fontSize = TitleProp ? 'XSmall' : 'extraSmall';
      var styledTabProps = {};
      if (this.isMobileDevice) styledTabProps['ariaLabel'] = "".concat(label, " tab ").concat(selected ? 'selected' : 'unselected', " \n              ").concat(this.props.index + 1, " of ").concat(numberOfTabs);

      if (!isDesktop || orientation === 'horizontal') {
        return /*#__PURE__*/React.createElement(StyledTab, _extends({
          tabSpacing: tabSpacing,
          id: "tab_".concat(uniqueId),
          minWidth: minWidth,
          minTabWidth: minTabWidth,
          onClick: this._onClick,
          onKeyDown: this._onKeyDown,
          role: this.isMobileDevice ? 'text' : 'presentation',
          className: className
        }, _defineProperty({}, this.refPath, this._setRef), {
          index: this.props.index,
          viewport: viewport,
          onBlur: this.props.onBlur
        }), /*#__PURE__*/React.createElement(StyledButton, _extends({
          accentFill: accentFill,
          indicatorFillTab: indicatorFillTab,
          accentPosition: accentPosition,
          indicatorPosition: indicatorPosition,
          selected: selected,
          label: label,
          uniqueId: uniqueId,
          tabHeight: tabHeight,
          focusState: focusState,
          minHeight: minHeight,
          typescale: typescale,
          titleConfig: titleConfig,
          colorConfig: colorConfig,
          clickStream: clickStream,
          analyticsTrack: analyticsTrack,
          track: track,
          position: position,
          level: level,
          cta: cta,
          inverted: inverted,
          dataTrack: dataTrack
        }, styledTabProps), label));
      }

      return /*#__PURE__*/React.createElement(ItemWrapper, {
        isDesktop: isDesktop,
        viewport: viewport,
        id: "tab_".concat(uniqueId),
        onClick: this._onClick,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        onKeyDown: this._onKeyDown,
        onBlur: this.props.onBlur
      }, /*#__PURE__*/React.createElement(ContentWrapper, _extends({
        tabIndex: active ? 0 : -1 // focus on active element first, then focus others with arrows
        ,
        selected: selected,
        currentClicked: currentClicked // this should be selected
        ,
        id: uniqueId,
        viewport: viewport,
        isDesktop: isDesktop,
        "aria-selected": selected,
        role: "tab",
        inverted: inverted,
        "data-analyticstrack": analyticsTrack,
        "data-track": track,
        "data-clickstream": clickStream
      }, _defineProperty({}, this.refPath, this._setRef), {
        colorConfig: colorConfig
      }), hitArea && /*#__PURE__*/React.createElement(HitArea, {
        tabIndex: -1
      }), /*#__PURE__*/React.createElement(TabContent, {
        className: "tabContent",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement(Title, {
        size: fontSize,
        color: currentClicked ? inverted ? colorConfig.white : colorConfig.black : colorConfig.coolGray6
      }, label))));
    }
  }]);

  return Tab;
}(Component);
Tab.propTypes = propTypes;
Tab.defaultProps = defaultProps;
export default withVDSManager(Tab);